<template>
  <div>
    <b-row>
      <b-col cols="12">
        <cumulatives-filter :get-report-data="getCumulatives" />
      </b-col>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <b-col
        v-else
        cols="12"
      >
        <b-row>
          <b-col cols="12">
            <b-card>
              <b-row>
                <b-col
                  cols="12"
                >
                  <flat-card
                    :value="cumulatives.grandTotal.sales"
                    color="success"
                    icon="CheckCircleIcon"
                    title="Genel Toplam"
                  />
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                >
                  <b-list-group class="mt-2">
                    <b-list-group-item
                      v-for="(cumulative,key) in cumulatives.data"
                      :key="key"
                    >
                      <div class="d-flex align-items-center justify-content-between">
                        <div>{{ cumulative.title }}</div>
                        <div>
                          <b-badge variant="primary">
                            {{ cumulative.sales }}
                          </b-badge>
                        </div>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                >
                  <pie-charts
                    :categories-data="cumulatives.grandTotal.chartData.labels"
                    :series-data="cumulatives.grandTotal.chartData.series"
                    chart-type="donut"
                    chart-title="Marka Bazlı Satışlar"
                    :is-card="false"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BCard, BListGroup, BListGroupItem, BBadge,
} from 'bootstrap-vue'
import CumulativesFilter from '@/views/I2Sales/FilterCards/CumulativesFilter.vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import FlatCard from '@/layouts/components/ReportCards/FlatCard.vue'
import PieCharts from '@/layouts/components/ReportCharts/PieCharts.vue'

export default {
  name: 'I2SalesCumulatives',
  components: {
    LoadingCard,
    CumulativesFilter,
    FlatCard,
    PieCharts,
    BRow,
    BCol,
    BCard,
    BListGroup,
    BListGroupItem,
    BBadge,
  },
  computed: {
    loading() {
      return this.$store.getters['i2SalesReports/loading']
    },
    cumulatives() {
      return this.$store.getters['i2SalesReports/cumulatives']
    },
    cumulativesParams() {
      return this.$store.getters['i2SalesReports/cumulativesParams']
    },
  },
  created() {
    this.getCumulatives()
  },
  methods: {
    getCumulatives() {
      this.$store.dispatch('i2SalesReports/getCumulatives', this.cumulativesParams)
    },
  },
}
</script>
